import { forwardRef } from 'react';
import { Drawer } from 'vaul';
import { clsx } from '@team/clsx';
import { ContentProps } from '../../types';
import css from './style.module.css';

export const Layout = forwardRef<HTMLDivElement, ContentProps>(
  function Component(
    { className, children, preventScroll = false, withInsets = true, ...props },
    forwardedRef
  ) {
    return (
      <Drawer.Content
        {...props}
        className={clsx(
          className,
          css.root,
          !preventScroll && css.scrollable,
          withInsets && css.insets
        )}
        ref={forwardedRef}
      >
        <div
          className={clsx(css.inner, { [css.preventScroll]: preventScroll })}
        >
          {children}
        </div>
      </Drawer.Content>
    );
  }
);
